import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import { priceFormatter } from 'utils/Numbers';
import { buildProductStructuredData } from 'utils/StructuredData';
import AffirmContainer from 'containers/AffirmContainer/AffirmContainer';
import classes from './CardProductG.module.scss';

const CardProductG = (props) => {
  const { item = {} } = props;

  const {
    displayName,
    imageURI,
    imageAltText = '',
    imageHeight,
    imageWidth,
    price,
    originalPrice,
    button,
    isAffirmEligible,
  } = item || {};

  const structuredData = buildProductStructuredData(item);

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: structuredData }}
        />
        <div className={classes.imageContainer}>
          {imageURI &&
            <img
              className={classes.image}
              src={imageURI}
              alt={imageAltText}
              width={imageWidth}
              height={imageHeight}
              loading='lazy'
            />}
        </div>
        <div className={classes.infoContainer}>
          {displayName &&
          <div
            className={classes.displayName}
            dangerouslySetInnerHTML={{ __html: displayName }}
          />}
          {price >= 0 && <div className={classes.price}>{priceFormatter(price)}</div>}
          {originalPrice > price && <div className={classes.originalPrice}>{priceFormatter(originalPrice)}</div>}
          {price >= 0 &&
            <div className={classes.affirmMessage}>
              <AffirmContainer price={price} isAffirmEligible={isAffirmEligible} className={classes.affirmMessage} />
            </div>}
          {button &&
            <div className={classes.buttonContainer}>
              {BuildChildren(button)}
            </div>}
        </div>
      </div>
    </div>
  );
};

const itemT = PropTypes.shape({
  /**
   * Image URI
  */
  imageURI: PropTypes.string,
  imageAltText: PropTypes.string,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  displayName: PropTypes.string,
  price: PropTypes.number,
  originalPrice: PropTypes.number,
  button: PropTypes.object,
  isAffirmEligible: PropTypes.bool,
});

CardProductG.propTypes = {
  /**
   * Product info:<br>
   * Format: {<br>
   * imageURI: string,<br>
   * imageAltText: string,<br>
   * imageHeight: number,<br>
   * imageWidth: number,<br>
   * displayName: string,<br>
   * price: number,<br>
   * originalPrice: number,<br>
   * button: object,<br>
   * }
  */
  item: PropTypes.objectOf(itemT),
};

export default CardProductG;
